import React, { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

function Login() {
  const [error, setError] = useState("");
  const { loginWithRedirect, isLoading } = useAuth0();

  const handleLogin = async () => {
    setError("");
    try {
      console.log("[Auth0] login button clicked");
      await loginWithRedirect({
        appState: { returnTo: "/new-record" },
      });
      console.log("[Auth0] loginWithRedirect resolved (redirect should occur)");
    } catch (e) {
      console.error("[Auth0] loginWithRedirect error", e);
      setError(e?.message || "Login failed. Please try again.");
    }
  };

  return (
    <>
      <section className="bg-gray-50 dark:bg-gray-900">
        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
          <a
            href="#"
            className="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white"
          >
            <img
              className="w-40 h-16 mr-2"
              src="https://money-trove.com/wp-content/uploads/2019/06/trove-logo-standard-300.png"
              alt="logo"
            ></img>
          </a>
          <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
            <div className="p-6 space-y-4 md:space-y-6 sm:p-8 text-center">
              <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white text-center">
                Sign in to your account
              </h1>

              {error ? (
                <div className="flex justify-center px-6 py-2 text-red-500">
                  {error}
                </div>
              ) : null}

              <button
                onClick={handleLogin}
                className="button login w-full text-white bg-slate-700 hover:bg-slate-600 focus:ring-4 focus:ring-slate-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-slate-600 dark:hover:bg-slate-600 focus:outline-none dark:focus:ring-slate-600 disabled:opacity-60"
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Log In"}
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Login;
